'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _republishMessage = require('../../actions/PublishActions/republishMessage');

var _getChatHeadingConfig = require('../../chat-heading-config/selectors/getChatHeadingConfig');

var _showAvailabilityMessageInWidget = require('../../availability/selectors/showAvailabilityMessageInWidget');

var _getAvailabilityOfficeHoursWillReturnMessage = require('../../availability/selectors/getAvailabilityOfficeHoursWillReturnMessage');

var _getAvailabilityTypicalResponseTimeMessage = require('../../availability/selectors/getAvailabilityTypicalResponseTimeMessage');

var _navigateToStagedThread = require('../../navigation/actions/navigateToStagedThread');

var _navigateToThreadList = require('../../navigation/actions/navigateToThreadList');

var _getAssignedResponderInWidget = require('../../responders/selectors/getAssignedResponderInWidget');

var _getChatHeadingResponders = require('../../responders/selectors/getChatHeadingResponders');

var _getColoring = require('../../selectors/widgetDataSelectors/getColoring');

var _getIsUngatedForNewHeader = require('../../selectors/widgetDataSelectors/getIsUngatedForNewHeader');

var _getCurrentConversation = require('../../selectors/conversationSelectors/getCurrentConversation');

var _getIsMobile = require('../../selectors/getIsMobile');

var _calculateUnseenThreadsCountExcludeCurrent = require('../../threads/selectors/calculateUnseenThreadsCountExcludeCurrent');

var _getShowThreadListButton = require('../../threads/selectors/getShowThreadListButton');

var _VisitorWidget = require('conversations-internal-components/visitor-widget/components/VisitorWidget');

var _VisitorWidget2 = _interopRequireDefault(_VisitorWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var requestStatus = state.requestStatus;

  var currentConversation = (0, _getCurrentConversation.getCurrentConversation)(state);
  return {
    chatHeadingConfig: (0, _getChatHeadingConfig.getChatHeadingConfig)(state),
    chatHeadingResponders: (0, _getChatHeadingResponders.getChatHeadingResponders)(state),
    coloring: (0, _getColoring.getColoring)(state),
    currentConversation: currentConversation,
    isThreadAssigned: Boolean((0, _getAssignedResponderInWidget.getAssignedResponderInWidget)(state)),
    mobile: (0, _getIsMobile.getIsMobile)(state),
    officeHoursMessage: (0, _getAvailabilityOfficeHoursWillReturnMessage.getAvailabilityOfficeHoursWillReturnMessage)(state),
    showAvailabilityMessage: (0, _showAvailabilityMessageInWidget.showAvailabilityMessageInWidget)(state, {
      thread: currentConversation
    }),
    showThreadListButton: (0, _getShowThreadListButton.getShowThreadListButton)(state),
    typicalResponseTimeMessage: (0, _getAvailabilityTypicalResponseTimeMessage.getAvailabilityTypicalResponseTimeMessage)(state),
    ungatedForNewHeader: (0, _getIsUngatedForNewHeader.getIsUngatedForNewHeader)(state),
    unseenThreadsCountExcludingCurrentThread: (0, _calculateUnseenThreadsCountExcludeCurrent.calculateUnseenThreadsCountExcludeCurrent)(state),
    widgetDataStatus: requestStatus.widgetData
  };
};

var mapDispatchToProps = {
  fetchAgentResponderIfNecessary: function fetchAgentResponderIfNecessary() {},
  createNewThread: _navigateToStagedThread.navigateToStagedThread,
  republishMessage: _republishMessage.republishMessage,
  showThreadList: _navigateToThreadList.navigateToThreadList
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_VisitorWidget2.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/visitor-widget/containers/VisitorWidgetContainer.js
// module id = 507
// module chunks = 2 3